import { render, staticRenderFns } from "./BenchmarkMetrics.vue?vue&type=template&id=a4334896&"
import script from "./BenchmarkMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./BenchmarkMetrics.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports